export async function requestOshiTags(url, {tagIds, generation, cursor} = {}) {
  const target = new URL(url, window.location.origin);
  if (tagIds) tagIds.forEach(id => target.searchParams.append('tag_ids[]', String(id)));
  if (generation) target.searchParams.set('generation', generation);
  if (cursor) target.searchParams.set('cursor', cursor);
  const response = await fetch(target.toString(), {credentials: 'same-origin', cache: 'no-store'});
  let body;
  try { body = await response.json(); }
  catch { throw Object.assign(new Error('Invalid response'), {status: response.status}); }
  if (!response.ok || body?.status !== 'OK' || !body.result || typeof body.result !== 'object') {
    throw Object.assign(new Error('Request failed'), {status: response.status});
  }
  return body.result;
}
